module.exports = __webpack_public_path__ + "static/logo_mobile-600ab9e88d9ed94095e72f3344f21b52.svg";